import { render, staticRenderFns } from "./WeeklyPlan.vue?vue&type=template&id=02fdab0d&scoped=true"
import script from "./WeeklyPlan.vue?vue&type=script&lang=js"
export * from "./WeeklyPlan.vue?vue&type=script&lang=js"
import style0 from "./WeeklyPlan.vue?vue&type=style&index=0&id=02fdab0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fdab0d",
  null
  
)

export default component.exports